import React from 'react';
import { motion } from 'framer-motion';
import { CrosshairIcon, BoxIcon, ZapIcon, LockIcon } from 'lucide-react';
const features = [{
  title: 'Sniper Panel Pro (MT5)',
  description: 'Ejecución de lotaje automático basado en tu % de riesgo deseado.',
  icon: CrosshairIcon
}, {
  title: 'Algoritmo Pandora Box',
  description: 'Identificación visual de zonas de acumulación y break-out para el US30.',
  icon: BoxIcon
}, {
  title: 'Modo Scalping Extremo',
  description: 'Entradas y salidas en milisegundos para capturar movimientos rápidos en NY.',
  icon: ZapIcon
}, {
  title: 'Gestión de SL/TP Dinámica',
  description: 'Protege tus ganancias sin intervención manual estresante.',
  icon: LockIcon
}];
export function Features() {
  return <section className="py-20 bg-dark" data-id="element-57">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <div className="text-center mb-16" data-id="element-59">
          <h2 className="font-display text-3xl font-extrabold text-white uppercase tracking-wide" data-id="element-60">
            Arsenal <span className="text-primary" data-id="element-61">Táctico</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-62">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-panel p-8 rounded-sm hover:border-primary/50 transition-all duration-300 group hover:box-glow" data-id="element-63">
              <div className="w-14 h-14 bg-surfaceHighlight/50 rounded-sm flex items-center justify-center mb-6 group-hover:bg-primary/10 transition-colors border border-surfaceHighlight" data-id="element-64">
                <feature.icon className="w-7 h-7 text-primary" data-id="element-65" />
              </div>
              <h3 className="font-display font-bold text-lg text-white mb-3" data-id="element-66">
                {feature.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-67">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}